import { render } from "./OfferingDocument.vue?vue&type=template&id=d7c4246c"
import script from "./OfferingDocument.vue?vue&type=script&lang=js"
export * from "./OfferingDocument.vue?vue&type=script&lang=js"
script.render = render

export default script